"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapAttributesToMcpAttributes = exports.variableAttributesArrayToObject = void 0;
/**
 * Transforms an array of variable attributes in the format "name:value" to an array of objects.
 *
 * @param variableAttributes - The array of variable attributes.
 * @returns An array of objects containing the name and value pairs.
 */
function variableAttributesArrayToObject(variableAttributes) {
  return variableAttributes.map(variableAttribute => {
    const [name, value] = variableAttribute.split(':');
    return {
      name,
      value
    };
  });
}
exports.variableAttributesArrayToObject = variableAttributesArrayToObject;
/**
 * Maps the array of provided attributes to the format which Printagon understands.
 *
 * Including an exception for attributes like ["Prepress URL:https://print.prepress.cimpress.io/v2/print-prep?asynchronous=true"].
 *
 * @param attributes - The array of attributes.
 * @returns An object containing attribute key-value pairs.
 */
function mapAttributesToMcpAttributes(attributes) {
  return attributes.reduce((acc, attribute) => {
    const keyValues = attribute.split(':');
    const key = keyValues[0];
    let value = keyValues[1];
    if (keyValues.length > 2) {
      const [host, url] = keyValues.slice(1);
      value = "".concat(host, ":").concat(url);
    }
    acc[key] = value;
    return acc;
  }, {});
}
exports.mapAttributesToMcpAttributes = mapAttributesToMcpAttributes;